import { toggleFields } from '../modules/form-helpers.js';

new toggleFields(document.getElementById('afm-simulator-container'));

class BatterySimulator {
	constructor({ container, resultsContainer }) {
		if (!container) {
			throw new Error('container e undefined');
		}

		if (!resultsContainer) {
			throw new Error('resultsContainer e undefined');
		}

		this.container = container;
		this.resultsContainer = resultsContainer;

		try {
			this.data = JSON.parse(container.dataset.config);
		} catch (err) {
			console.error(err.message);
			throw new Error('Nu am putut decodifica container.dataset.config');
		}

		this.inverterSelect = container.querySelector('#inverter');
		if (!this.inverterSelect) {
			throw new Error('select#inverter e undefined');
		}

		this.phaseSelect = container.querySelector('#phase');
		if (!this.phaseSelect) {
			throw new Error('select#phase e undefined');
		}

		this.inverterSlider = {
			wrapper: container.querySelector('#inverter-power'),
			input: container.querySelector('#power'),
			tooltip: container.querySelector('#inverter-power .nj-tooltip__inner'),
		};
		if (Object.values(this.inverterSlider).some((v) => v == null)) {
			throw new Error('null sau undefined in inverterSlider');
		}

		this.batterySlider = {
			wrapper: container.querySelector('#capacity-container'),
			input: container.querySelector('#capacity'),
			tooltip: container.querySelector('#capacity-container .nj-tooltip__inner'),
		};
		if (Object.values(this.batterySlider).some((v) => v == null)) {
			throw new Error('null sau undefined in batterySlider');
		}

		this.balanceSlider = {
			wrapper: container.querySelector('#balance-container'),
			input: container.querySelector('#balance'),
		};
		if (Object.values(this.balanceSlider).some((v) => v == null)) {
			throw new Error('null sau undefined in balanceSlider');
		}

		this.stepWrappers = container.querySelectorAll('.step-wrapper');

		this.output = {
			batteryPrice: container.querySelector('#battery-price'),
			batteryScore: container.querySelector('#battery-score'),
			contribution: container.querySelector('#contribution'),
			afm: container.querySelector('#afm'),
			contributionScore: container.querySelector('#contribution-score'),
		};
		if (Object.values(this.output).some((v) => v == null)) {
			throw new Error('null sau undefined in output');
		}

		this.resultsOutput = {
			resultsTotalScore: resultsContainer.querySelector('#results-total-score'),
			resultsBatteryScore: resultsContainer.querySelector('#results-battery-score'),
			resultsContributionScore: resultsContainer.querySelector('#results-contribution-score'),
			batteryName: resultsContainer.querySelector('#results-battery-name'),
			resultsTotalPrice: resultsContainer.querySelector('#results-total-price'),
			resultsContribution: resultsContainer.querySelector('#results-contribution'),
			resultsAfm: resultsContainer.querySelector('#results-afm'),
		};
		if (Object.values(this.resultsOutput).some((v) => v == null)) {
			throw new Error('null sau undefined in resultsOutput');
		}

		this.backupWrapper = resultsContainer.querySelector('#results-backup');
		if (!this.backupWrapper) {
			throw new Error('fieldset#results-backup e undefined');
		}

		this.installmentsWrapper = resultsContainer.querySelector('#results-installments');
		if (!this.installmentsWrapper) {
			throw new Error('fieldset#results-installments e undefined');
		}

		this.showFormBtn = resultsContainer.querySelector('#show-form');
		if (!this.showFormBtn) {
			throw new Error('button#show-form e undefined');
		}

		this.targetForm = document.getElementById(container.dataset.formId);

		this.response = {
			wrapper: document.getElementById('afm-simulator-response-message'),
			title: document.querySelector('#afm-simulator-response-message .alert-title'),
			text: document.querySelector('#afm-simulator-response-message .alert-text'),
		};

		this.addListeners();
	}

	addListeners() {
		this.container.addEventListener('input', ({ target }) => {
			// Activare pasi
			for (const wrapper of this.stepWrappers) {
				// Skip la pasul de prosumator
				if (wrapper === this.stepWrappers[0]) {
					continue;
				}

				// Pasul de selectie invertor are nevoie doar sa fie prosumator
				if (wrapper.querySelector('#inverter')) {
					this.enable(wrapper, this.isProsumer);
					continue;
				}

				// Ceilalti pasi au nevoie si de un invertor selectat
				this.enable(wrapper, this.enabled);
			}

			// Selectie invertor
			if (target === this.inverterSelect || target === this.phaseSelect) {
				this.initInverterSlider();
				this.initBatterySlider();
				this.initBalanceSlider();
			}

			if (target === this.batterySlider.input) {
				this.initBalanceSlider();
			}

			this.updateInverterSlider();
			this.updateBatterySlider();
			this.updateBalanceSlider(target === this.batterySlider.input);

			// Activare radio din rezultate
			this.enable(this.backupWrapper, this.enabled);
			this.enable(this.installmentsWrapper, this.enabled);

			// Update UI calculator si rezultate
			this.updateOutput();
			this.activateButton();

			// Update local storage
			if (this.isProsumer) {
				localStorage.setItem('afm_simulation', JSON.stringify(this.state));
			} else {
				localStorage.removeItem('afm_simulation');
				if (this.targetForm) {
					this.targetForm.hidden = true;
				}
			}

			// Ascundere mesaj raspuns
			this.response.wrapper && (this.response.wrapper.hidden = true);
		});

		this.resultsContainer.addEventListener('input', () => {
			this.activateButton();
			localStorage.setItem('afm_simulation', JSON.stringify(this.state));

			// Ascundere mesaj raspuns
			this.response.wrapper && (this.response.wrapper.hidden = true);
		});

		this.showFormBtn.addEventListener('click', () => {
			localStorage.setItem('afm_simulation', JSON.stringify(this.state));

			if (this.targetForm) {
				this.targetForm.hidden = false;
				const header = document.getElementById('masthead');
				const headerHeight = header ? header.offsetHeight : 0;
				const extraOffset = 25;
				this.targetForm.style.scrollMarginTop = `${headerHeight + extraOffset}px`;
				this.targetForm.scrollIntoView({
					behavior: 'smooth',
				});
			}
		});

		document.addEventListener('formAfm:success', (e) => {
			const { responseTitle, responseText } = e.detail;

			this.reset();
			this.targetForm && (this.targetForm.hidden = true);

			// Afisare mesaj succes
			const { wrapper, title, text } = this.response;
			if (wrapper && title && text) {
				title.textContent = responseTitle;
				text.textContent = responseText;
				wrapper.hidden = false;

				// Scroll la mesaj
				const header = document.getElementById('masthead');
				const headerHeight = header ? header.offsetHeight : 0;
				const extraOffset = 25;
				wrapper.style.scrollMarginTop = `${headerHeight + extraOffset}px`;
				wrapper.scrollIntoView({
					behavior: 'smooth',
				});
			}
		});
	}

	reset() {
		this.container.querySelectorAll('[name="prosumer_status"]').forEach((option) => (option.checked = false));

		this.inverterSelect.value = '';

		this.inverterSlider.input.max = 1;
		this.inverterSlider.input.value = 0;
		this.inverterSlider.wrapper.style.setProperty('--tooltip-left', 'calc(var(--nj-slider-thumb-size) / 2)');
		this.inverterSlider.wrapper.style.setProperty('--nj-slider-track-position', '0% 100%');
		this.inverterSlider.tooltip.textContent = '';
		this.updateTicks(this.inverterSlider.wrapper);

		this.batterySlider.input.max = 1;
		this.batterySlider.input.value = 0;
		this.batterySlider.wrapper.style.setProperty('--tooltip-left', 'calc(var(--nj-slider-thumb-size) / 2)');
		this.batterySlider.wrapper.style.setProperty('--nj-slider-track-position', '0% 100%');
		this.batterySlider.tooltip.textContent = '';
		this.updateTicks(this.batterySlider.wrapper);

		this.balanceSlider.input.min = 0;
		this.balanceSlider.input.max = 1;
		this.balanceSlider.input.value = 0;
		this.balanceSlider.input.removeAttribute('style');
		const prevStep = this.balanceSlider.input.step;
		this.balanceSlider.input.step = 1;
		this.updateTicks(this.balanceSlider.wrapper);
		this.balanceSlider.input.step = prevStep;

		this.container.dispatchEvent(new Event('input'));
		this.resultsContainer.dispatchEvent(new Event('change', { bubbles: true }));
	}

	enable(wrapper, enabled) {
		if (wrapper.classList.contains('nj-radio-group')) {
			wrapper.classList.toggle('nj-radio--disabled', !enabled);
			wrapper.querySelectorAll('input[type="radio"]').forEach((radio) => {
				radio.disabled = !enabled;
				if (!enabled) {
					radio.checked = false;
				}
			});
			return;
		}

		wrapper.classList.toggle('disabled', !enabled);

		wrapper.querySelectorAll('.nj-form-item__field-wrapper, .nj-slider').forEach((elm) => {
			const className = elm.classList.contains('nj-slider') ? 'nj-slider--disabled' : 'nj-form-item--disabled';
			const selector = elm.classList.contains('nj-slider') ? 'input[type="range"]' : 'input, select, textarea';

			elm.classList.toggle(className, !enabled);
			elm.querySelector(selector) && (elm.querySelector(selector).disabled = !enabled);
		});
	}

	activateButton() {
		const { backup } = this.state;

		const isActive = this.enabled && typeof backup === 'boolean' && (typeof this.state.installments === 'boolean' || (typeof this.state.installments === 'number' && this.state.installments > 0));

		this.showFormBtn.disabled = !isActive;
		this.showFormBtn.hidden = !isActive;

		if (!isActive) {
			this.targetForm.hidden = true;
		}
	}

	initInverterSlider() {
		const { inverter } = this;

		if (!inverter) {
			return;
		}

		if (!this.phase) {
			this.phaseSelect.value = inverter.default_phase;
		}

		const { default_power, power_range } = inverter.phases[this.phase];

		const { wrapper, input } = this.inverterSlider;

		input.max = power_range.length - 1;
		input.value = default_power;

		this.updateTicks(wrapper);
	}

	updateInverterSlider() {
		const { inverter } = this;

		if (!inverter) {
			return;
		}

		const { wrapper, input, tooltip } = this.inverterSlider;
		const power = inverter.phases[this.phase].power_range[input.value];

		tooltip.textContent = power;

		const percentage = input.value / input.max;

		wrapper.style.setProperty('--nj-slider-track-position', `${percentage * 100}% 100%`);
		wrapper.style.setProperty('--tooltip-left', `calc(${percentage * 100}% - (${percentage} * var(--nj-slider-thumb-size)) + (var(--nj-slider-thumb-size) / 2))`);
	}

	initBatterySlider() {
		const { battery } = this;

		if (!battery) {
			return;
		}

		const { caps, default_cap } = battery;
		const { wrapper, input } = this.batterySlider;

		input.max = caps.length - 1;
		input.value = default_cap;

		this.updateTicks(wrapper);
	}

	updateBatterySlider() {
		const { battery } = this;

		if (!battery) {
			return;
		}

		const { wrapper, input, tooltip } = this.batterySlider;
		const { caps } = battery;
		const { cap } = caps[input.value ?? 0];

		tooltip.textContent = cap;

		const percentage = input.value / input.max;

		wrapper.style.setProperty('--nj-slider-track-position', `${percentage * 100}% 100%`);
		wrapper.style.setProperty('--tooltip-left', `calc(${percentage * 100}% - (${percentage} * var(--nj-slider-thumb-size)) + (var(--nj-slider-thumb-size) / 2))`);
	}

	initBalanceSlider() {
		const { wrapper, input } = this.balanceSlider;
		const { minContribution, maxContribution, price } = this.state;

		if (!(minContribution && maxContribution)) {
			return;
		}

		input.min = minContribution;
		input.max = maxContribution;
		input.value = minContribution;
		const step = Number(input.step) || 100;

		let sweetspotFrom;
		for (let userAmount = minContribution; userAmount <= maxContribution; userAmount += step) {
			const afmAmount = price - userAmount;
			const score = (userAmount * 30) / afmAmount;
			if (score >= 50) {
				sweetspotFrom = userAmount;
				break;
			}
		}

		this.updateTicks(wrapper, sweetspotFrom, step, 2);
	}

	updateBalanceSlider(updateValue = false) {
		const { wrapper, input } = this.balanceSlider;
		const { minContribution, maxContribution } = this.state;

		if (!(minContribution && maxContribution)) {
			return;
		}

		input.min = minContribution;
		input.max = maxContribution;
		if (updateValue) {
			input.value = minContribution;
		}

		const percentage = (input.value - input.min) / (input.max - input.min);

		wrapper.style.setProperty('--nj-slider-track-position', `${percentage * 100}% 100%`);
		wrapper.style.setProperty('--progress', `${percentage * 100}%`);

		const value = percentage * 100;
		const threshold = parseFloat(input.style.getPropertyValue('--sweetspot-from'));
		const filledColor = value < threshold ? '--nj-core-color-red-500' : '--nj-core-color-engie-green';
		input.style.setProperty('--filled-color', `var(${filledColor})`);
	}

	formatNumber(num, digits = 2, integerDigits = 5) {
		if (isNaN(num)) {
			return num;
		}

		return new Intl.NumberFormat('ro-RO', {
			minimumIntegerDigits: integerDigits,
			minimumFractionDigits: digits,
			maximumFractionDigits: digits,
		}).format(num);
	}

	updateOutput() {
		const { batteryPrice, batteryScore, contribution, afm, contributionScore } = this.output;
		const { resultsTotalScore, resultsBatteryScore, resultsContributionScore, batteryName, resultsTotalPrice, resultsContribution, resultsAfm } = this.resultsOutput;
		const { price, batteryScore: battScore, contributionScore: contribScore, totalScore, contributionAmount, afmAmount } = this.state;

		// Update simulator
		batteryPrice.textContent = this.formatNumber(price || 0);
		batteryScore.textContent = this.formatNumber(battScore || 0, 1, 2);
		contribution.textContent = this.formatNumber(contributionAmount || 0);
		afm.textContent = this.formatNumber(afmAmount || 0);
		contributionScore.textContent = this.formatNumber(contribScore || 0, 1, 2);

		// Update rezultate
		const resTotalScore = this.enabled ? totalScore || '-' : '-';
		const resBattScore = this.enabled ? battScore || '-' : '-';
		const resContribScore = this.enabled ? contribScore || '-' : '-';
		const resPrice = this.enabled ? price || '-' : '-';
		const resContributionAmount = this.enabled ? contributionAmount || '-' : '-';
		const resAfmAmount = this.enabled ? afmAmount || '-' : '-';

		resultsTotalScore.textContent = this.formatNumber(resTotalScore, 1, 1);
		resultsBatteryScore.textContent = this.formatNumber(resBattScore, 1, 1);
		resultsContributionScore.textContent = this.formatNumber(resContribScore, 1, 1);
		batteryName.textContent = this.enabled && this.battery ? this.battery.battery_name : '-';
		resultsTotalPrice.textContent = this.formatNumber(resPrice);
		resultsContribution.textContent = this.formatNumber(resContributionAmount);
		resultsAfm.textContent = this.formatNumber(resAfmAmount);
	}

	updateTicks(sliderWrapper, sweetspotFrom = null, defaultStep = 1, stepMultiplier = 1) {
		const input = sliderWrapper.querySelector('input[type="range"]');

		if (!input) {
			return;
		}

		let ticksWrapper = sliderWrapper.querySelector('.ticks');
		if (!ticksWrapper) {
			ticksWrapper = document.createElement('div');
			ticksWrapper.classList.add('ticks');
			ticksWrapper.setAttribute('aria-hidden', 'true');
			sliderWrapper.appendChild(ticksWrapper);
		}

		const min = Number(input.min);
		const max = Number(input.max);
		const step = Number(input.step) || defaultStep;

		let innerHtml = '';

		for (let i = min; i <= max; i += step * stepMultiplier) {
			const classes = ['tick'];

			if (i === min || i === max) {
				classes.push('major');
			}

			if (sweetspotFrom) {
				input.classList.add('has-sweetspot');
				const percentage = ((sweetspotFrom - min) / (max - min)) * 100;
				input.style.setProperty('--sweetspot-from', `${percentage}%`);
				if (i < sweetspotFrom) {
					classes.push('badspot');
				} else {
					classes.push('sweetspot');
				}
			}

			innerHtml += `<span class="${classes.join(' ')}"></span>`;
		}

		ticksWrapper.innerHTML = innerHtml;
	}

	get state() {
		const { battery, inverter, phase } = this;

		if (!battery) {
			return {};
		}

		if (!this.enabled) {
			return {};
		}

		const { input } = this.batterySlider;
		const { battery_id: batteryId, battery_name: batteryName, caps } = battery;
		const { cap: rawCap, price: rawPrice } = caps[input.value ?? 0];
		const { inverter_id: inverterId, inverter_name: inverterName } = inverter;

		const batteryCapacity = Number(rawCap);
		const batteryScore = Math.min(50, batteryCapacity * 2.5);
		const price = Number(rawPrice);

		// Contributia beneficiarului trebuie sa fie minim 25% dar afm nu trebuie sa depaseasca 15000
		const minContribution = Math.max(price / 4, price - 15000);
		const maxContribution = price - 1000; // Limitam afm la minim 1000, altfel nu are sens sa aplice pt. afm zero

		// Valori dinamice
		const contributionAmount = Number(this.balanceSlider.input.value);
		const afmAmount = price - contributionAmount;
		const contributionScore = Math.min(50, (contributionAmount * 30) / afmAmount);
		const totalScore = batteryScore + contributionScore;

		// Backup si rate
		const { backup, installments } = this;
		// const installmentValue = installments ? contributionAmount / installments : 0;

		// Putere invertor
		const { input: inverterInput } = this.inverterSlider;
		const inverterPower = inverter.phases[this.phase].power_range[inverterInput.value];

		return {
			inverterId,
			inverterName,
			inverterPower,
			phase,
			batteryId,
			batteryName,
			batteryCapacity,
			price,
			minContribution,
			maxContribution,
			contributionAmount,
			afmAmount,
			batteryScore,
			batteryScoreRounded: Math.round(batteryScore * 10) / 10,
			contributionScore,
			contributionScoreRounded: Math.round(contributionScore * 10) / 10,
			totalScore,
			totalScoreRounded: Math.round(totalScore * 10) / 10,
			backup,
			installments,
		};
	}

	get isProsumer() {
		const prosumerOptions = this.container.querySelectorAll('[name="prosumer_status"]');
		if (!prosumerOptions.length) {
			throw new Error('Nu am gasit niciun radio name="prosumer_status"');
		}

		return this.container.querySelector('[name="prosumer_status"]:checked')?.value === 'yes';
	}

	get backup() {
		const backupOptions = this.resultsContainer.querySelectorAll('[name="results_backup"]');
		if (!backupOptions.length) {
			throw new Error('Nu am gasit niciun radio name="results_backup"');
		}

		const checkedOption = this.resultsContainer.querySelector('[name="results_backup"]:checked');
		return checkedOption ? checkedOption.value === 'yes' : undefined;
	}

	get installments() {
		const checkedOption = this.resultsContainer.querySelector('[name="results_installments"]:checked');

		if (!checkedOption) {
			return undefined;
		}

		return checkedOption.value === 'yes';
	}

	get inverter() {
		return this.data.find((item) => item.inverter_id === this.inverterSelect.value);
	}

	get battery() {
		return this.inverter?.phases[this.phase]?.battery;
	}

	get enabled() {
		return !!(this.isProsumer && this.inverter);
	}

	get phase() {
		return this.phaseSelect.value;
	}
}

function initSimulator() {
	new BatterySimulator({
		container: document.getElementById('afm-battery-simulator'),
		resultsContainer: document.getElementById('afm-simulator-results'),
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initSimulator);
} else {
	initSimulator();
}
